// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"8f5e39ba","238":"70553d4b","381":"87e72511","523":"bd222ef9"}[chunkId] + ".chunk.js";
};